import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

const name = "selectedInvestorFilter";
const initialState = {
  selectedInvestorFilter: "All",
  loading: false,
  error: null,
};

export const selectInvestorFilter = createAsyncThunk(
  "selectInvestorFilter",
  async (filter) => {
    return filter;
  }
);

const selectInvestorFilterSlice = createSlice({
  name,
  initialState,
  extraReducers: (builder) => {
    builder.addCase(selectInvestorFilter.fulfilled, (state, action) => {
      state.selectedInvestorFilter = action.payload;
      state.loading = false;
      state.error = null;
    });
  },
});

export default selectInvestorFilterSlice.reducer;
